// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2tzEt","content":"RecentSearches_content__2QpoI"};